// extracted by mini-css-extract-plugin
module.exports = {"repo":"Repo-module--repo--3YuEY","bar":"Repo-module--bar--2xfTg","github-link":"Repo-module--github-link--1HSP0"};